__turbopack_context__.v({
  "appCtas": "appRating-module-scss-module__VXRNPW__appCtas",
  "appRating": "appRating-module-scss-module__VXRNPW__appRating",
  "card": "appRating-module-scss-module__VXRNPW__card",
  "gradient": "appRating-module-scss-module__VXRNPW__gradient",
  "phoneImage": "appRating-module-scss-module__VXRNPW__phoneImage",
  "qrCode": "appRating-module-scss-module__VXRNPW__qrCode",
  "rating": "appRating-module-scss-module__VXRNPW__rating",
  "ratingBlock": "appRating-module-scss-module__VXRNPW__ratingBlock",
  "reviewCount": "appRating-module-scss-module__VXRNPW__reviewCount",
  "stars": "appRating-module-scss-module__VXRNPW__stars",
});
